module.exports = __webpack_public_path__ + "static/bg-page-1-192db802cccc76f0adf2db5fd705e3e4.jpg";